import React from 'react';
import PropTypes from 'prop-types';
import { Link } from 'react-router-dom';
import { connect } from 'react-redux';
import { getQuestion } from '../selectors';
import Arrow from './Arrow';

const QuizSectionQuestion = ({
  quizSectionIndex,
  questionID,
  question: {
    title,
    userAnsweredCorrectly,
    userHasAnswered,
  },
}) => (
  <Link to={`/quiz/${quizSectionIndex}/${questionID}`}>
    {userHasAnswered && !userAnsweredCorrectly
        && (
        <li className="f6 f5-ns flex items-start justify-between lh-copy pv3 ph3 bg-white mv1 incorrect-color" key={questionID}>
          <span className="w-90 mw-90">{title}</span>
          <i className="material-icons incorrect-color pl2">close</i>
        </li>
        )
        }
    {userHasAnswered && userAnsweredCorrectly
        && (
        <li className="f6 f5-ns flex items-start justify-between lh-copy pv3 ph3 bg-white mv1 correct-color" key={questionID}>
          <span className="w-90 mw-90">{title}</span>
          <i className="material-icons correct-color pl2">check</i>
        </li>
        )
      }
    {!userHasAnswered
        && (
        <li className="f6 f5-ns flex items-start justify-between lh-copy pv3 ph3 bg-white mv1" key={questionID}>
          <span className="w-90 mw-90">{title}</span>
          <Arrow />
        </li>
        )
      }
  </Link>
);

QuizSectionQuestion.propTypes = {
  quizSectionIndex: PropTypes.number.isRequired,
  questionID: PropTypes.string.isRequired,
  question: PropTypes.shape({
    title: PropTypes.string.isRequired,
    userAnsweredCorrectly: PropTypes.bool.isRequired,
    userHasAnswered: PropTypes.bool.isRequired,
  }).isRequired,
};

function mapStateToProps(state, ownProps) {
  return {
    question: getQuestion(state, ownProps),
  };
}

export default connect(mapStateToProps)(QuizSectionQuestion);



// WEBPACK FOOTER //
// ./src/components/QuizSectionQuestion.js